export default __webpack_public_path__ + "static/media/pinHC.6d096f45.svg";